import { createStore } from 'vuex'
import { snackbar } from './snackbar/snackbar.js'
import { loading } from './loading/loading.js'
import { dialog } from './dialog/dialog.js'
import { workflows } from './workflows/workflows.js'
import { workflow } from './workflow/workflow.js'
import { debounceUpdateWorkflow } from './debounce/debounceUpdateWorkflow.js'
import { workflowHistory } from './workflowHistory/workflowHistory.js'
import { teamMembers } from './teamMembers/teamMembers.js'
import { projectMemberships } from './teamMembers/projectMemberships.js'
import { organisations } from './organisations/organisations.js'
import { project } from './project/project.js'
import { cardTypes } from './cardTypes/cardTypes.js'
import { user } from './user/user.js'
import { jira } from './jira/jira.js'
import { svgGraphData } from './workflow/svgGraphData.js'
import { synchronizedScrolling } from './synchronizedScrolling/synchronizedScrolling.js'
import { boundedContexts } from './workflow/boundedContexts.js'
import { payments } from './payments/payments'
import subscriptionClient from '@/graphql/subscriptionClient'
import { subscriptions } from '@/store/admin/subscriptions/subscriptions'
import { enterpriseCustomers } from '@/store/admin/enterprise-customers/enterprise-customers'
import { chatLog } from './chatLog/chatLog'
import { github } from './github/github'

export default createStore({
  strict: true,
  state: {
    isUserLoggedIn: localStorage.getItem('isUserLoggedIn') === 'true' || false,
    userInfo: localStorage.getItem('userInfo') || null,
    adminUser: localStorage.getItem('adminUser') === 'true' || false,
    userId: localStorage.getItem('userId') || null,
    sidePanelTab: 'cards',
    showSidePanel: false,
    pinSidePanel: false,
    hasClosedSidePanel: false,
    svgGraph: {},
    svgLanes: {},
    isWorkflowDisabled: false,
    wsMessageForCypress: null,
    domainModelShowEntities: true,
    domainModelShowReadModels: true,
    domainModelShowEventDetails: false,
    interactionMode: 'hand'
  },
  mutations: {
    login (state, data) {
      state.isUserLoggedIn = true
      state.userInfo = data.email
      state.adminUser = data.adminUser
      state.userId = data.userId

      localStorage.setItem('isUserLoggedIn', 'true')
      localStorage.setItem('userInfo', data.email)
      localStorage.setItem('adminUser', data.adminUser)
      localStorage.setItem('userId', data.userId)
    },
    logout (state) {
      subscriptionClient.close()
      state.isUserLoggedIn = false
      state.userInfo = ''
      state.adminUser = false
      state.userId = null

      localStorage.removeItem('isUserLoggedIn')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('adminUser')
      localStorage.removeItem('userId')

      state.workflow.workflow = {}
      state.workflows.workflows = null
      state.workflows.demoWorkflows = null
      state.workflowHistory.workflowHistory = null
      state.teamMembers.teamMembers = []
      state.projectMemberships.projectMemberships = null
      state.organisations.organisations = null
      state.cardTypes.cardTypes = null
      state.user.user = null
      state.svgGraph = {}
      state.svgLanes = {}
      state.isWorkflowDisabled = false
      state.wsMessageForCypress = null
      state.jiraIssues = null
      state.boundedContexts.boundedContexts = {}
      state.payments.subscriptionType = 'yearly'
      state.payments.plan = null
      state.payments.users = []
      state.payments.totalPrice = 0
      state.payments.paymentMethod = null
      state.payments.subscriptionUsers = null
      state.payments.activeSubscription = null
      state.payments.trialJustStarted = false
      state.payments.campaignTrialJustClaimed = false
      state.loading.loadingCount = 0
      state.loading.loadingMessage = null
      state.loading.loadingActiveSubscription = false
    },
    syncWorkflowDisabled (state) {
      const isAdminWithoutMembership = state.adminUser &&
        state.teamMembers.teamMembers?.findIndex((tm) => tm.userId === state.userId) === -1

      state.isWorkflowDisabled = state.workflow.isViewOnlyEnabled === true ||
        state.workflow.workflow?.status === 2 ||
        state.payments.subscriptionAccessType !== 'FULL' ||
        isAdminWithoutMembership === true
    },
    setWsMessageForCypress (state, data) {
      state.wsMessageForCypress = data
    },
    updateSvgGraph (state, data) {
      state.svgGraph = data
    },
    updateSvgLanes (state, data) {
      state.svgLanes = data
    },
    showSidePanel (state, show) {
      if (state.pinSidePanel && !show) {
        return true
      }
      state.showSidePanel = show
    },
    pinSidePanel (state, pin) {
      state.pinSidePanel = pin
    },
    setSidePanelTab (state, tabId) {
      state.sidePanelTab = tabId
    },
    setHasClosedSidePanel (state, hasClosed) {
      state.hasClosedSidePanel = hasClosed
    },
    setDomainModelShowEntities (state, show) {
      state.domainModelShowEntities = show
    },
    setDomainModelShowReadModels (state, show) {
      state.domainModelShowReadModels = show
    },
    setDomainModelShowEventDetails (state, show) {
      state.domainModelShowEventDetails = show
    },
    setInteractionMode (state, mode) {
      state.interactionMode = mode
    }
  },
  actions: {
  },
  modules: {
    snackbar,
    loading,
    dialog,
    workflows,
    workflow,
    workflowHistory,
    teamMembers,
    projectMemberships,
    organisations,
    project,
    cardTypes,
    user,
    jira,
    svgGraphData,
    synchronizedScrolling,
    boundedContexts,
    debounceUpdateWorkflow,
    payments,
    subscriptions,
    enterpriseCustomers,
    chatLog,
    github
  }
})
